import { createFormHook } from '@tanstack/react-form';
import { fieldContext, formContext } from './tanstack-form.context';
import { lazy } from 'react';
//NOTE: There is no point in lazy loading the Submit button because it's needed always to 'submit' the form
import { CMSFormSubmit } from './cms-form-submit';

const CMSInputText = lazy(() => import('./cms-input-text'));
const CMSInputTextArea = lazy(() => import('./cms-input-text-area'));
const CMSSelect = lazy(() => import('./cms-select'));

export const { useAppForm, withForm } = createFormHook({
  fieldComponents: {
    CMSInputText,
    CMSInputTextArea,
    CMSSelect,
  },
  formComponents: {
    CMSFormSubmit,
  },
  fieldContext,
  formContext,
});
